import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";
import { ContactProfileDetailsContext } from "../macrocomponents/ContactLayout";
import { getTextColorBasedOnBG, HeaderSvgBgSring } from "app/utils/utils";
import { getSessionStore } from "app/utils/sessionStore";
import { Badge } from "primereact/badge";
import { isEmpty } from "ramda";
import { useNotificationClick } from "app/hooks/useNotificationClick";
import { ThemeContext } from "../macrocomponents/RootLayout";
import { checkChatConversationExists, getPrimaryChatBot, getUIPCredentials } from "lib/utils";

const encodeSvg = (svg: string) => `data:image/svg+xml;base64,${btoa(svg)}`;

function ContactDashBoardHeader() {
  const navigate = useNavigate();
  const { contactFirstName, isOpen, contactId, agentID } = useContext(ContactProfileDetailsContext);
  const { branding } = getSessionStore("lookUpResponse");
  const { isDarkMode: checked } = useContext(ThemeContext);
  const {
    secondaryColor = "",
    bannerLogo = "",
    bannerLogoDark = "",
    primaryColor = "",
  } = branding ?? {};
  const showChatDot = getSessionStore("showChatDot");
  const showNotificationDot = getSessionStore("showNotificationDot");
  const onNotificationClick = useNotificationClick();
  const svgString = secondaryColor ? HeaderSvgBgSring(secondaryColor) : HeaderSvgBgSring();
  const [backgroundImage, setBackgroundImage] = useState(encodeSvg(svgString));
  useEffect(() => {
    if (checked) {
      if (typeof bannerLogoDark === "string" && bannerLogoDark?.length > 0) {
        setBackgroundImage(bannerLogoDark);
      } else {
        setBackgroundImage(encodeSvg(svgString));
      }
    } else if (typeof bannerLogo === "string" && bannerLogo?.length > 0) {
      setBackgroundImage(bannerLogo);
    } else {
      const lightSvgString = HeaderSvgBgSring(primaryColor || "#002446");
      setBackgroundImage(encodeSvg(lightSvgString));
    }
  }, [bannerLogo, bannerLogoDark, checked]);

  const handleChatClick = async () => {
    const primaryBot = await getPrimaryChatBot();
    if (!primaryBot?.id) {
      navigate("/chat");
      return;
    }

    const creds = await getUIPCredentials(primaryBot.id);
    if (!creds?.uip_token) {
      navigate("/chat");
      return;
    }

    const conversationData = await checkChatConversationExists(
      contactId,
      agentID,
      creds.uip_token,
      "user",
      "user",
    );
    const conversationId =
      conversationData?.id ||
      conversationData?.conversation_id ||
      conversationData?.response?.conversation_id ||
      null;

    navigate("/chat", {
      state: {
        activeConversationId: conversationId,
        botId: primaryBot.id,
      },
    });
  };

  // const backgroundImage = encodeSvg(svgString);
  return (
    <div
      style={{
        height: "180px",
        // backgroundColor: secondaryColor,
        // backgroundImage: `url(${backgroundImage})`,
        // backgroundSize: "cover",
        // backgroundRepeat: "no-repeat",
        // backgroundPosition: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="w-full fixed z-50"
    >
      <img
        src={backgroundImage}
        alt="Banner"
        className=" absolute h-full object-cover -z-10 w-full"
      />
      <div className={`h-6  ${isOpen ? "w-63 mr-6" : "w-32 mr-4"}`} />
      <div className="h-full" style={{ flex: isOpen ? 4 : 6 }}>
        <div className="flex justify-between items-center h-full">
          {contactFirstName ? (
            <p
              className="text-2xl font-semibold pt-3 ml-2 mt-3"
              style={{ fontFamily: "Inter", color: getTextColorBasedOnBG(secondaryColor) }}
            >
              {`Welcome Back, ${contactFirstName}!`}
            </p>
          ) : (
            <Skeleton width="20rem" height="3rem" borderRadius="16px" className="mb-2" />
          )}
          <div className="h-full mr-8 pt-3 flex">
            <div
              className="mb-auto align-self-center cursor-pointer inline rounded-full  "
              onClick={() => {
                handleChatClick();
              }}
            >
              <i className="pi pi-comments p-overlay-badge p-2 bg-headerIconsBgPrimary text-white rounded-full headerIcon hover:cursor-pointer hover:bg-opacity-85">
                <Badge
                  className={`chat-icon ${isEmpty(showChatDot) || !showChatDot ? "hidden" : ""}`}
                />
              </i>
            </div>
            <div
              onClick={onNotificationClick}
              style={{ width: "32px", height: "32px" }}
              className="mb-auto flex justify-center items-center align-self-center cursor-pointer notification-bell-parent ml-4 bg-headerIconsBgPrimary  rounded-full  hover:cursor-pointer"
            >
              <i className="pi pi-bell p-overlay-badge headerIcon rounded-full hover:bg-opacity-85 text-white">
                <Badge
                  className={`notification-bell ${
                    isEmpty(showNotificationDot) || !showNotificationDot ? "hidden" : ""
                  }`}
                />
              </i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactDashBoardHeader;
